import React from "react";
import "../../Css/HomePage/HomeAbout.css";
import aboutimage01 from "../../Images/twentythreea.jpg";
import aboutimage02 from "../../Images/Sunset-Room/Sunset-Room-01.jpg";
import { Slide } from "react-awesome-reveal";
import { NavLink } from "react-router-dom";
const HomeAbout = (() => {
    return (
        <>
            <section className="container-fluid home-page-about-section">
                <div className="container">
                    <div className="home-page-about-section-main-con">
                        <div className="row">
                            <div className="col-md-6">
                                <Slide>
                                <div className="home-page-about-section-images-main-con">
                                    <div className="home-page-about-section-images-first">
                                        <img src={aboutimage01} alt="img"/>
                                    </div>
                                    <div className="home-page-about-section-images-second">
                                        <img src={aboutimage02} alt="img"/>
                                    </div>
                                </div>
                                </Slide>
                            </div>
                            <div className="col-md-6">
                                <Slide direction="right">
                                <div className="home-page-about-section-details-main-con">
                                    <div className="home-page-about-section-details-con">
                                        <h2>HOTEL LUXURY</h2>
                                        <h3>Seema's Resort</h3>
                                        <p style={{textAlign:'justify'}}>Located in the stunning Neral hills, Seema Resort is a tranquil haven that is ideal for anyone looking for a restorative time surrounded by the splendour of nature. Our resort in Nerul is surrounded by thick vegetation and offers a tranquil atmosphere that makes it the perfect place to escape the daily grind. It also boasts stunning views of the Western Ghats. Whether you're looking for adventure, leisure, or time.                                        </p>
                                        <p style={{textAlign:'justify'}}>Our resort in Neral provides a range of tastefully decorated apartments and lodgings to suit all kinds of tourists. Modern conveniences in every room provide a relaxing and pleasurable stay. Our resort combines the elegance of modern life with the allure of nature, offering cosy, private rooms as well as roomy suites. Our serene settings and cosy lodgings offer the ideal environment for unwinding after a day of sightseeing.                                        </p>
                                        <div className="home-page-about-section-details-btn">
                                            <NavLink to="/top-resort-neral" style={{textDecoration:"none"}}>
                                            <button  className="btn btn-lg btn-dark my-2 mb-4 d-flex" style={{
                                backgroundColor:"black",
                                borderRadius:"0"
                            }}>
                                                Learn More
                                            </button>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                                </Slide>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
});

export default HomeAbout;